import React from "react";
import { Tooltip, Chip, Box } from "@mui/material";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import { getInitial } from "../../services/utils/name-utils";
import TimeTableWeekEvents from "./Time-table-week-events";
import TimeTableJoinNow from "../day-event/Time-table-join-now";

const TimeTableWeekEvent = ({
  event,
  refetch,
  SDate,
  EDate,
  setIsCreateLinkClicked,
}) => {
  if (!event) return null;

  const currentTime = new Date();
  const eventStartTime = new Date(event?.StartTime);
  const eventEndTime = new Date(event?.EndTime);

  const diff =
    new Date(event.EndTime).getTime() - new Date(event.StartTime).getTime();
  const minutes = Math.round(Math.abs(diff) / 60000);

  const now = Date.now();
  const start = new Date(event.StartTime).getTime();
  const end = new Date(event.EndTime).getTime();

  const isLive = now >= start && now <= end;
  const hasLiveSession = event.Events?.some((e) => e.name === "bbb_lecture");

  const isHappened = currentTime.getTime() > eventEndTime.getTime();
  const isEventHappening =
    currentTime.getTime() >= eventStartTime.getTime() &&
    currentTime.getTime() <= eventEndTime.getTime();

  return (
    <div
      className="w-100 mb-1"
      style={{
        background: "#fff",
        borderRadius: 10,
        padding: minutes <= 30 ? "6px 8px" : "8px 10px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
      }}
    >
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center">
        {/* Subject / Lecture */}
        <div
          style={{
            fontSize: 13,
            fontWeight: 600,
            maxWidth: 140,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color:
              event.LactureType === "general_lacture" ? "#ffa55c" : "#1f2937",
          }}
        >
          {event.LactureType === "general_lacture" ? (
            event.LectureName.toUpperCase()
          ) : (
            <Tooltip title={event.Subject} arrow>
              <span>{event.Subject}</span>
            </Tooltip>
          )}
        </div>

        {/* RIGHT SIDE */}
        <div className="d-flex align-items-center gap-2">
          {event.TeacherName && (
            <Tooltip title={event.TeacherName} arrow>
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: 26,
                  height: 26,
                  borderRadius: "50%",
                  background: "#1976d2",
                  color: "#fff",
                  fontSize: 12,
                  fontWeight: 600,
                }}
              >
                {getInitial(event.TeacherName)}
              </div>
            </Tooltip>
          )}
        </div>
      </div>

      {/* {hasLiveSession && (
        <div className="d-flex justify-content-center mt-1">
          <Chip
            icon={<LiveTvIcon />}
            label={isLive ? "LIVE" : "REC"}
            size="small"
            color={isLive ? "error" : "default"}
            sx={{ height: 22 }}
          />
        </div>
      )} */}
      {/* {hasLiveSession && (
        <div className="d-flex justify-content-center mt-1">
          <span className={`badge ${isLive ? "bg-danger" : "bg-secondary"}`}>
            {isLive ? "🟢" : "🔴"}
          </span>
        </div>
      )} */}
      <div className="d-flex flex-row align-items-center gap-2 ">
        {event.LactureType !== "general_lacture" &&
          !event.bbb_lecture_id &&
          event.Events[0] !== "Planner" && (
            <span style={{ fontSize: "16px" }}>🏫</span>
          )}

        {event.LactureType !== "general_lacture" &&
          event.bbb_lecture_id &&
          event.Events[0] !== "Planner" && (
            <span style={{ fontSize: "16px" }}>💻</span>
          )}

        {event.Events[0] !== "Planner" &&
          event.LactureType !== "general_lacture" && (
            <>
              {isEventHappening && <span>🟢</span>}
              {!isEventHappening && !isHappened && <span>⏳</span>}
              {isHappened && <span>✅</span>}
            </>
          )}

        <Box>
          <TimeTableWeekEvents event={event} />
        </Box>
      </div>

      {/* JOIN BUTTON */}
      {/* {hasLiveSession && isLive && (
        <div className="d-flex justify-content-end mt-1">
          <TimeTableJoinNow
            event={event}
            refetch1={refetch}
            SDate={SDate}
            EDate={EDate}
            setIsCreateLinkClicked={setIsCreateLinkClicked}
          />
        </div>
      )} */}

      {/* FOOTER ICONS */}
      <Box className="mt-1">
        <TimeTableWeekEvents event={event} />
      </Box>
    </div>
  );
};

export default TimeTableWeekEvent;
